export const FETCH_ADDRESS_FROM_GSTIN = 'FETCH_ADDRESS_FROM_GSTIN';
export const FETCH_COMPANY_NAME_FROM_PAN = 'FETCH_COMPANY_NAME_FROM_PAN';
